<template>
  <div>
    <v-app-bar
      color="primary"
      dense
      fixed
      dark
      app
      class="toolbar"
      style="z-index: 3;"
    >
      <v-app-bar-nav-icon @click.stop="showLeftMenu()"></v-app-bar-nav-icon>

      <v-toolbar-title>
        <router-link 
          :to="{name:'ListReference'}" 
          tag="span" 
          style="cursor: pointer"
        >
          <div class="d-flex align-center">
            <v-img
              alt="Vuetify Logo"
              class="shrink mr-2"
              contain
              src="https://brodelec.fr/images/logo-blanc.png"
              transition="scale-transition"
              width="40"
            />
            <span class="d-none d-sm-block">Brodelec Store</span>
          </div>
        </router-link>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-chip
        class="ma-2 text-body-1"
        color="red"
        text-color="white"
        link
        v-if="isCartRecoveryAvailable"
        @click="openRecoverOldCartDialog()"
      >
        <v-icon left>
          mdi-alert
        </v-icon>
        Un problème avec le panier ? Tenter la récupération
      </v-chip>

      <v-spacer></v-spacer>

      <span class="mr-5" v-if="isAuthenticated">{{ user }}</span>   

      <v-divider vertical></v-divider>  

      <v-btn 
        icon
        @click.stop="showCart()"
        v-if="isAuthenticated"
      >
        <v-badge
          :content="cartQty"
          :value="cartQty"
          color="green"
          overlap
        >
          <v-icon>mdi-cart</v-icon>
        </v-badge>
      </v-btn>

    </v-app-bar>
  </div>
  
</template>

<script>
  // EVENTS
  import { EventBus } from '@/main.js'
  import { SHOW_CART } from '@/store/actions/cart'
  import { SHOW_LEFT_MENU, SHOW_RECOVER_CART_DIALOG } from '@/store/actions/general'
  // VUEX
  import { mapGetters } from 'vuex'

  export default {
    name: 'Topbar',

    data() {
      return {
        colors: this.$vuetify.theme.themes.light,
      }
    },

    computed: {
      ...mapGetters({
        isAuthenticated: 'isAuthenticated',
        cartQty: 'cartQty',
        user: 'displayUserName',
        isCartRecoveryAvailable: 'isCartRecoveryAvailable',
      }),
      chosenCustomer() {
        let string = ''
        if (this.$store.getters.isAdmin && this.$store.getters.hasCustomer) {
          string = `Client sélectionné : ${this.$store.getters.getCustomer.text}`
        }

        return string
      },
    },

    methods: {
      showCart() {
        this.$store.commit(SHOW_CART)
      },
      showLeftMenu() {
        this.$store.commit(SHOW_LEFT_MENU)
      },
      openRecoverOldCartDialog() {
        // this.$store.dispatch(RECOVER_OLD_CART)
        EventBus.$emit(SHOW_RECOVER_CART_DIALOG)
      },
    },
  };
</script>

<style scoped>
  .v-application a {
    color: #fff;
    text-decoration: none;
  }
  .toolbar {
    max-height: 56px;
  }
  @media (min-width: 947px) {
    .toolbar {
      max-height: 64px;
    }
  }
</style>
